<div class="hero-home__container mx-auto">

    <section class="hero">
        <div class="hero-inner">
            <div class="hero-grid">
                <div class="hero-left">
                    <p class="hero-eyebrow">{{ copy.eyebrow }}</p>

                    <h1 class="hero-title">
                        {{ copy.titleLine1 }}<br>
                        {{ copy.titleLine2 }}
                    </h1>

                    <p class="hero-subtitle">
                        {{ copy.subtitle }}
                    </p>

                    <div class="hero-cta">
                        <a class="btn btn-primary" [routerLink]="['/buenos-aires-tours', lang]">{{ copy.cta }}</a>
                    </div>

                    <!--
                        Trustline: solo USPs, NO rating. El rating + reviews ya viven
                        en la <ta-card> a la derecha — antes salía duplicado.
                    -->
                    <div class="hero-trustline">
                        <span>{{ copy.smallGroups }}</span>
                        <span class="dot">&bull;</span>
                        <span>{{ copy.freeCancellation }}</span>
                    </div>
                </div>

                <aside class="ta-card" aria-label="Tripadvisor Travelers' Choice 2024">
                    <div class="ta-card__shine" aria-hidden="true"></div>

                    <div class="ta-single-logo">
                        <img class="ta-single-logo__image"
                            src="/assets/imgs/image_9362ada55-removebg-preview.png"
                            alt="Tripadvisor badge"
                            width="220" height="220"
                            fetchpriority="high" loading="eager" decoding="async">
                    </div>

                    <div class="ta-rating-box" [attr.aria-label]="copy.rating4Of5InTripadvisor">
                        <div class="ta-rating-inline">
                            <span class="ta-stars" aria-hidden="true" style="--fill:94%;">★★★★★</span>
                            <div class="ta-number">4.7</div>
                        </div>
                        <div class="ta-meta">{{ copy.reviewsLabel }}</div>
                    </div>
                </aside>
            </div>
        </div>
    </section>
</div>
